import config from '../config';

const artlabs = config({
  default: {
    default: {
      /** Whether the artlabs integration is enabled generally. */
      enabled: false,
      /** Whether to show the main PDP. */
      showMainPDP: false,
      /** Whether to show the coming soon PDP. */
      showComingSoonPDP: false,
      /** The token for the Artlabs account, this is a public token. */
      token: '',
      /** AR icon. */
      arIcon: '',
      /** VTO icon. */
      vtoIcon: '',
      /** The script for the Artlabs account. */
      script:
        'https://assets.artlabs.ai/js/experience/latest/artlabs-experience.umd.js',
      /** Optional logo URL for VTO onboarding experience. */
      logoUrl: '',
      /** Optional onboarding mode for VTO experience. */
      onboarding: false
    }
  },
  'HOKA-US': {
    default: {
      enabled: true,
      token: 'zHozfuwdPrVadQybOIB1giYwNKqCGAvwONGQKihgEA',
      arIcon:
        'https://dms.deckers.com/hoka/image/upload/t_AutoEco/v1775594830/S22-HOKA-Artlabs-box_9d8cbb.png',
      vtoIcon:
        'https://dms.deckers.com/hoka/image/upload/t_AutoEco/v1774300574/S22-HOKA-Artlabs-shoe-blk.png'
    }
  },
  'UGG-US': {
    default: {
      enabled: false,
      token: 'bbpaXZt3cSNqGodRKbWUV8preHFTgjNPHFg5GjhxAZ'
    }
  },
  'TEVA-US': {
    default: {
      enabled: true,
      token: 'MHYYNxtZeTeqfLToTHlkTNEYq9DTKBsaATN9FrJPYQ',
      arIcon:
        'https://dms.deckers.com/tevaus/image/upload/t_AutoEco/v1775593435/Cube_62445e.png',
      vtoIcon:
        'https://dms.deckers.com/tevaus/image/upload/t_AutoEco/v1745587944/artlabs-shoe-icon.png'
    }
  }
});

export default artlabs;
